module.exports = __webpack_public_path__ + "cut.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/cut.svg?color1=%23333333&color2=
// module id = 2195
// module chunks = 67